import type { BannerBlock } from '@/types'
import { BlockTypes } from '@/types'

import Model from './Model'

export default class BlockBannerModel extends Model {
  static model: BannerBlock = {
    type: BlockTypes.Banner1,
    id: null,
    name: null,
    active: true,
    parameters: {
      title: null,
      banners: [
        {
          image: null,
          title: null,
          subtitle: null,
          action: null,
          link: null,
          color_text: '#ffffff',
        },
        {
          image: null,
          title: null,
          subtitle: null,
          action: null,
          link: null,
          color_text: '#ffffff',
        },
        {
          image: null,
          title: null,
          subtitle: null,
          action: null,
          link: null,
          color_text: null,
        },
        {
          image: null,
          title: null,
          subtitle: null,
          action: null,
          link: null,
          color_text: null,
        },
      ],
    },
  }

  static get() {
    return super.get() as BannerBlock
  }

  static prepare(model: Partial<BannerBlock>, without: (keyof BannerBlock)[]) {
    return super.prepare(model, without)
  }
}
